/*
 * Vencord, a Discord client mod
 * Copyright (c) 2024 Vendicated and contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */

export const DEFAULT_CHUNK_SIZE = 256;
export const DEFAULT_COLOR = 10070709;

export const SWATCHES = [
    1752220,
    3066993,
    3447003,
    10181046,
    15277667,
    15844367,
    15105570,
    15158332,
    9807270,
    6323595,

    1146986,
    2067276,
    2123412,
    7419530,
    11342935,
    12745742,
    11027200,
    10038562,
    9936031,
    5533306
];
